<template>
  <header class="header">
    <div class="container-sm">
      <div class="row">
        <div class="col-md-12 col-lg-12">
          <nav class="navbar fixed-top">
            <div class="container">
              <div class="logoBox">
                <a
                  class="navbarBrand"
                  href="#/"
                  title="Postmedia Parcel Services"
                >
                  <img src="../assets/logo.png" />
                </a>
              </div>
              <div class="navbar_menu">
                <div class="headerTextLink">
                  <a href="#/track-your-shipment">TRACK YOUR SHIPMENT</a>
                </div>
                <div id="menu" @click="dropdownMenuToggle()">
                  <div class="menuLine1"></div>
                  <div class="menuLine2"></div>
                  <div class="menuLine3"></div>
                </div>
                <div class="headerTextLink langLink">
                  <a class="lang-lini" @click="goToFrenchVersion()">FR</a>
                </div>
                <div class="nav-page1" id="">
                  <ul>
                    <div class="menu-header-menu-container">
                      <ul id="menu-header-menu" class="menu">
                        <li
                          id="menu-item-225"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-225"
                        >
                          <a href="#/track-your-shipment/"
                            >Track Your Shipment</a
                          >
                        </li>
                        <li
                          id="menu-item-156"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-156"
                        >
                          <a href="#/partners/">Business Solutions</a>
                        </li>
                        <li
                          id="menu-item-154"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-154"
                        >
                          <a href="#/couriers/">Delivery Agents</a>
                        </li>
                        <li
                          id="menu-item-156"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-154"
                        >
                          <a href="#/careers/">Careers</a>
                        </li>
                        <li
                          id="menu-item-157"
                          class="menu-item menu-item-type-post_type menu-item-object-page menu-item-157"
                        >
                          <a href="#/support/">Support</a>
                        </li>
                      </ul>
                    </div>
                  </ul>
                </div>
                <div class="nav-page2"></div>
              </div>
            </div>
          </nav>
        </div>
      </div>
    </div>
  </header>
</template>

<script>
/* eslint-disable */

export default {
  mounted() {
    let currentMenuClass = document.querySelector("#menu").classList;
    let menuLine1Class = document.querySelector(".menuLine1").classList;
    let menuLine2Class = document.querySelector(".menuLine2").classList;
    let menuLine3Class = document.querySelector(".menuLine3").classList;

    let navPage1Class = document.querySelector(".nav-page1").classList;
    let navPage2Class = document.querySelector(".nav-page2").classList;

    currentMenuClass.remove("rotate");
    menuLine1Class.remove("rotate1");
    menuLine2Class.remove("rotate2");
    menuLine3Class.remove("rotate2");

    navPage1Class.remove("transform");
    navPage2Class.remove("transform");
  },
  methods: {
    dropdownMenuToggle() {
      let currentMenuClass = document.querySelector("#menu").classList;
      let menuLine1Class = document.querySelector(".menuLine1").classList;
      let menuLine2Class = document.querySelector(".menuLine2").classList;
      let menuLine3Class = document.querySelector(".menuLine3").classList;

      let navPage1Class = document.querySelector(".nav-page1").classList;
      let navPage2Class = document.querySelector(".nav-page2").classList;

      if (currentMenuClass.contains("rotate")) {
        currentMenuClass.remove("rotate");
        menuLine1Class.remove("rotate1");
        menuLine2Class.remove("rotate2");
        menuLine3Class.remove("rotate2");

        navPage1Class.remove("transform");
        navPage2Class.remove("transform");
      } else if (!currentMenuClass.contains("rotate")) {
        currentMenuClass.add("rotate");
        menuLine1Class.add("rotate1");
        menuLine2Class.add("rotate2");
        menuLine3Class.add("rotate2");

        navPage1Class.add("transform");
        navPage2Class.add("transform");
      }
    },
    goToFrenchVersion() {
      let currentPagePath = this.$route.name;
      if (currentPagePath == "home-page") {
        this.$router.push("/fr");
      } else {
        let path = "";
        if (currentPagePath == "tracking-page")
          path = "/fr/track-your-shipment";
        else if (currentPagePath == "courier-page") path = "/fr/couriers";
        else if (currentPagePath == "career-page") path = "/fr/careers";
        else if (currentPagePath == "partners-page") path = "/fr/partners";
        else if (currentPagePath == "support-page") path = "/fr/support";
        else if (currentPagePath == "about-page") path = "/fr/about-postmedia";
        else if (currentPagePath == "copyright-page") path = "/fr/copyright";
        else if (currentPagePath == "privacy-policy-page") path = "/fr/google-apps-policy";
        else if (currentPagePath == "email-opt-out") path = "/fr/email-opt-out/:accountid";
        this.$router.push(path);
      }
    },
  },
  name: "page-header",
  components: {},
};
</script>
